export default __webpack_public_path__ + "static/media/calendar.efeecba7.svg";